import {
  PlayerCommunityEvent,
  PlayerCommunityEventReward,
} from '../../state/communityJackpot.types';

const getLastCompletedMilestone = (event: PlayerCommunityEvent) => {
  const completedMilestones = event.milestones.filter(
    ({ status }) => status === 'Completed' || status === 'RewardPending',
  );

  return completedMilestones[completedMilestones.length - 1];
};

export const getMilestoneWinners = (event: PlayerCommunityEvent) => {
  const { prizes = [] } = getLastCompletedMilestone(event) || {};

  return prizes.reduce(
    (accumulator, prize) => accumulator + prize.numberOfRewards,
    0,
  );
};

export const getRewardsAmount = (rewards: PlayerCommunityEventReward[]) =>
  Number(
    rewards
      .reduce((accumulator, { rewardAmount }) => accumulator + rewardAmount, 0)
      .toFixed(0),
  );

export const getJackpotReward = (rewards: PlayerCommunityEventReward[]) =>
  rewards.find(
    ({ rewardType }) => rewardType === 'CommunityEventJackpotReward',
  );

export const getJackpotMilestone = (
  event: PlayerCommunityEvent,
  jackpotReward?: PlayerCommunityEventReward,
) =>
  jackpotReward &&
  event.milestones.find(({ id }) => id === jackpotReward.milestoneId);
